import { CHANNELS } from 'constants/Channels';
import ufeApi from 'services/api/ufeApi';

/**
 * Places an immediate order for a replenishment subscription.
 *
 * @param {Object} params - Request parameters.
 * @param {string} params.subscriptionId - The subscription identifier to order now.
 * @returns {Promise<Object>} A promise that resolves with the order response data.
 * @throws {Object} Throws the API response object when the request returns errors or a failure status.
 */
async function orderNow({ subscriptionId }) {
    const { sdnUfeAPIUserKey } = Sephora.configurationSettings;
    const { country, language } = Sephora.renderQueryParams;
    const url = `/gway/v1/replenishment/${subscriptionId}/get-it-now?apikey=${sdnUfeAPIUserKey}`;

    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Site-Locale': country,
            'Site-Language': language,
            'x-requested-source': CHANNELS.RWD
        }
    };

    const data = await ufeApi.makeRequest(url, options);

    if (data?.errors || data?.responseStatus >= 400) {
        throw data;
    }

    return data;
}

export default orderNow;
